<div class="viz-layout">
  <!-- Left Column: Version Files -->
  <div class="viz-left-panel">
    <div class="viz-files-card">
      <div class="viz-card-title-row">
        <h4 class="viz-card-title">Version Files</h4>
      </div>

      <div class="viz-loading" *ngIf="loadingFiles">
        <div class="viz-spinner"></div>
        <p>Loading files...</p>
      </div>

      <div class="viz-file-list" *ngIf="!loadingFiles && displayFiles.length > 0">
        <div
          *ngFor="let file of displayFiles"
          class="viz-file-item"
          [class.selected]="selectedFile?.name === file.name"
          [class.disabled]="!isFileSupportedForVisualisation(file)"
          (click)="isFileSupportedForVisualisation(file) && onSelectedFileChange(file)"
        >
          <svg class="viz-file-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path d="M13 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V9L13 2Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M13 2V9H20" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <span class="viz-file-name">{{ file.name }}</span>
        </div>
      </div>

      <div class="viz-no-files" *ngIf="!loadingFiles && !loading && displayFiles.length === 0">
        <p>No files available</p>
      </div>

    </div>
  </div>

  <!-- Right Column: Chart -->
  <div class="viz-right-panel">
    <div class="viz-chart-card">
      <div class="viz-chart-header">
            <h4 class="viz-chart-title">
              Visualisation for
              <span *ngIf="selectedFile?.name" class="viz-chart-file"> {{ selectedFile?.name }}</span>
            </h4>
            <div
              class="viz-chart-metadata"
              *ngIf="selectedFile && (selectedFileSizeDisplay || selectedFileLastUpdatedDisplay || license)"
            >
              <div class="viz-chart-metadata-row" *ngIf="selectedFileSizeDisplay">
                <span class="viz-chart-metadata-label">File size</span>
                <span class="viz-chart-metadata-value">{{ selectedFileSizeDisplay }}</span>
              </div>
              <div class="viz-chart-metadata-row" *ngIf="selectedFileLastUpdatedDisplay">
                <span class="viz-chart-metadata-label">Last updated</span>
                <span class="viz-chart-metadata-value">{{ selectedFileLastUpdatedDisplay }}</span>
              </div>
              <div class="viz-chart-metadata-row" *ngIf="license">
                <span class="viz-chart-metadata-label">License</span>
                <span class="viz-chart-metadata-value">{{ license }}</span>
              </div>
            </div>

            <div class="viz-chart-separator" *ngIf="selectedFile"></div>
      </div>

      <div class="viz-loading" *ngIf="loading">
        <div class="viz-spinner"></div>
        <p>Loading data...</p>
      </div>

      <div class="viz-error" *ngIf="error && !loading">
        <p>{{ error }}</p>
      </div>

      <div class="viz-chart-content" *ngIf="!loading && !error && tableData.length > 0">
        <div class="viz-chart-config">
          <div class="viz-controls">
            <div class="viz-control-group">
              <label class="viz-control-label">Chart Type</label>
              <select class="viz-select" [value]="chartType" (change)="onChartTypeChange($event)">
                <option *ngFor="let type of chartTypes" [value]="type.key">{{ type.label }}</option>
              </select>
            </div>

            <div class="viz-control-group">
              <label class="viz-control-label">{{ chartTypeLabel === 'Line Chart' ? 'X-Axis' : 'Dimension' }}</label>
              <select class="viz-select" [value]="selectedDimension" (change)="onDimensionChange($event)">
                <option *ngFor="let h of tableHeaders" [value]="h">{{ h }}</option>
              </select>
            </div>

            <div class="viz-control-group" *ngIf="chartTypeLabel === 'Line Chart'">
              <label class="viz-control-label">Y-Axis</label>
              <select class="viz-select" [value]="selectedSeries" (change)="onSeriesChange($event)">
                <option *ngFor="let h of tableHeaders" [value]="h">{{ h }}</option>
              </select>
            </div>

            <div class="viz-control-group" *ngIf="(chartTypeLabel === 'Bar Chart' || chartTypeLabel === 'Pie Chart')">
              <label class="viz-control-label">Metric</label>
              <select class="viz-select" [value]="selectedMetric" (change)="onMetricChange($event)">
                <option *ngFor="let m of metricTypes" [value]="m">{{ m }}</option>
              </select>
            </div>

            <div class="viz-control-group" *ngIf="selectedColumnIsNumeric && selectedMetric !== 'count' && chartTypeLabel !== 'Line Chart' && groupByColumns.length > 0">
              <label class="viz-control-label">Group By</label>
              <select class="viz-select" [value]="selectedGroupByColumn" (change)="onGroupByColumnChange($event)">
                <option *ngFor="let g of groupByColumns" [value]="g">{{ g }}</option>
              </select>
            </div>
          </div>
        </div>

        <div class="viz-chart-area">
          <div echarts [options]="chartOptions" class="viz-echart"></div>
        </div>
      </div>

      <div class="viz-empty" *ngIf="!loading && !error && tableData.length === 0 && selectedFile">
        <p>No data to visualise. Select a supported file (CSV, TSV, XLSX, Parquet, JSON).</p>
      </div>

      <div class="viz-empty" *ngIf="!loading && !error && !selectedFile && displayFiles.length > 0">
        <p>Select a file from the list to visualise</p>
      </div>
    </div>
  </div>
</div>
